

























































import { Component, Vue, Prop, Model } from 'vue-property-decorator'
import { Header } from '@/components/molecules/SmTableData.vue'
import { ownersModule } from '@/stores/owners-store'
import { Owner } from '@/dtos/owners/get'

@Component({
  components: {
    SmBtn: () => import('@/components/atoms/SmBtn.vue'),
    SmText: () => import('@/components/atoms/SmText.vue'),

    SmTableData: () => import('@/components/molecules/SmTableData.vue'),
    SmTextField: () => import('@/components/molecules/SmTextField.vue'),

    SmModal: () => import('@/components/organisms/SmModal.vue'),
  }
})
export default class ConsultationsOwnerSelectModal extends Vue {
  @Model('input', { required: true })
  private readonly isModalVisible!: boolean

  // textfieldに入力された値
  @Prop({ default: '' })
  inputText!:string

  // 検索時にコンポーネント(SmTableData)に検索ワードを渡すための変数
  @Prop({ default: '' })
  keyword!:string

  private get _isModalVisible(): boolean { return this.isModalVisible }
  private set _isModalVisible(newValue: boolean) {
    this.$emit('input', newValue)
  }

  private get _inputText(): string { return this.inputText }
  private set _inputText(newValue: string) { this.$emit('update:inputText', newValue) }

  private get _keyword(): string { return this.keyword }
  private set _keyword(newValue: string) { this.$emit('update:keyword', newValue) }

  // 相談・連絡一覧画面のcreated()でstoreに取得済み
  private get owners(): Owner[] { return ownersModule.ownersGet.owners }

  headers: Header[] = [
    new Header({ text: '住戸番号', value: 'roomNumber', width: '112px' }),
    new Header({ text: '氏名', value: 'userName', sortable: false }),
  ]

  // 住戸番号列の昇順／降順の切替えを数値として行うために指定するオブジェクト
  customSorts = {
    roomNumber: {
      sortMethod: (a: Owner, b: Owner): number => {
        const aNumStr = a.roomNumber.match(/\d+/)
        const aNum = aNumStr ? parseInt(aNumStr.toString()) : 0
        const bNumStr = b.roomNumber.match(/\d+/)
        const bNum = bNumStr ? parseInt(bNumStr.toString()) : 0

        return aNum - bNum
      }
    }
  }

  textValue = ''

  // SmTableDataの返却値（配列）を格納するための変数。当モーダルは単一選択のため返却値は一つのみ。
  selectedUserId: string[] = []

  search():void {
    this._keyword = this._inputText
  }

  goToConsultationDetail(): void {
    this.$emit('selected-user', this.selectedUserId[0])
  }
}
